import React__default from 'react';
import PropTypes__default from 'prop-types';
import { Helmet } from 'react-helmet';

var SEO = function SEO(_ref) {
  var title = _ref.title,
    description = _ref.description,
    image = _ref.image,
    isArticle = _ref.isArticle,
    locale = _ref.locale,
    href = _ref.href,
    noFollow = _ref.noFollow,
    noIndex = _ref.noIndex;
  return /*#__PURE__*/React__default.createElement(Helmet, {
    title: title
  }, noFollow && /*#__PURE__*/React__default.createElement("meta", {
    name: "robots",
    content: "nofollow"
  }), noIndex && /*#__PURE__*/React__default.createElement("meta", {
    name: "robots",
    content: "noindex"
  }), locale && /*#__PURE__*/React__default.createElement("meta", {
    property: "og:locale",
    content: locale
  }), href && /*#__PURE__*/React__default.createElement("meta", {
    property: "og:url",
    content: href
  }), /*#__PURE__*/React__default.createElement("meta", {
    name: "description",
    content: description
  }), (isArticle ? true : null) && /*#__PURE__*/React__default.createElement("meta", {
    property: "og:type",
    content: "article"
  }), title && /*#__PURE__*/React__default.createElement("meta", {
    property: "og:title",
    content: title
  }), description && /*#__PURE__*/React__default.createElement("meta", {
    property: "og:description",
    content: description
  }), image && /*#__PURE__*/React__default.createElement("meta", {
    property: "og:image",
    content: image
  }), /*#__PURE__*/React__default.createElement("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), title && /*#__PURE__*/React__default.createElement("meta", {
    name: "twitter:title",
    content: title
  }), description && /*#__PURE__*/React__default.createElement("meta", {
    name: "twitter:description",
    content: description
  }), image && /*#__PURE__*/React__default.createElement("meta", {
    name: "twitter:image",
    content: image
  }));
};
SEO.propTypes = {
  title: PropTypes__default.string,
  description: PropTypes__default.string,
  image: PropTypes__default.string,
  locale: PropTypes__default.string,
  isArticle: PropTypes__default.bool,
  href: PropTypes__default.string,
  noFollow: PropTypes__default.bool,
  noIndex: PropTypes__default.bool
};

export { SEO as default };
//# sourceMappingURL=SEO.js.map
